export const DEVIS = {
    SET_ITEMS: 'SET_DEVIS_ITEMS',
    ADD_ITEMS: 'ADD_DEVIS_ITEMS',
    SET_ITEM: 'SET_DEVIS_ITEM',
    RESET_ITEMS: 'RESET_DEVIS_ITEMS',

    SET_PAGE: 'SET_DEVIS_PAGE',
    SET_NB_OF_PAGES: 'SET_DEVIS_NB_OF_PAGES',
    SET_SCROLL: 'SET_DEVIS_SCROLL',

    SET_SORT: 'SET_DEVIS_SORT',
    RESET_FILTER: 'DEVIS_RESET_FILTER',
    SET_FILTER_DEVIS_ID: 'DEVIS_SET_FILTER_DEVIS_ID',
    SET_FILTER_DEVIS_NUMERO_COMMANDE: 'DEVIS_SET_FILTER_DEVIS_NUMERO_COMMANDE',
    SET_FILTER_DEVIS_NUM_FACTURE: 'DEVIS_SET_FILTER_DEVIS_NUM_FACTURE',
    SET_FILTER_DATE_DEBUT: 'SET_FILTER_DATE_DEBUT',
    SET_FILTER_DATE_FIN: 'SET_FILTER_DATE_FIN',
    ADD_FILTER_SITE: 'DEVIS_ADD_FILTER_SITE',
    REMOVE_FILTER_SITE: 'DEVIS_REMOVE_FILTER_SITE',
    SET_FILTER_SITE: 'DEVIS_SET_FILTER_SITE',
    ADD_FILTER_STATUS: 'DEVIS_ADD_FILTER_STATUS',
    REMOVE_FILTER_STATUS: 'DEVIS_REMOVE_FILTER_STATUS',
    SET_FILTER_STATUS: 'DEVIS_SET_FILTER_STATUS',
    SET_COUNT: 'DEVIS_SET_COUNT',

    SET_IS_LOADING: 'SET_DEVIS_IS_LOADING',
    SET_ERROR: 'SET_DEVIS_ERROR',

    CLEAR_ALL: 'DEVIS_CLEAR_ALL',

    ADD_BONCOMMANDE: 'DEVIS_ADD_BONCOMMANDE',
    REMOVE_BONCOMMANDE: 'DEVIS_REMOVE_BONCOMMANDE',

    SET_EXPORT_XLS_IS_LOADING: 'SET_SUIVI_DEVIS_EXPORT_XLS_IS_LOADING',

    SET_SORT_INTERVENTIONS: 'SET_INTERVENTIONS_SORT',
    SET_SCROLL_INTERVENTIONS: 'SET_INTERVENTIONS_SCROLL',
    RESET_ITEMS_INTERVENTIONS: 'RESET_INTERVENTIONS_ITEMS',

    SET_PAGE_INTERVENTIONS: 'SET_INTERVENTIONS_PAGE',
    SET_NB_OF_PAGES_INTERVENTIONS: 'SET_INTERVENTIONS_NB_OF_PAGES',
    SET_IS_LOADING_INTERVENTIONS: 'SET_INTERVENTIONS_IS_LOADING',
    SET_ERROR_INTERVENTIONS: 'SET_INTERVENTIONS_ERROR',
    SET_ITEMS_INTERVENTIONS: 'SET_INTERVENTIONS_ITEMS',
    ADD_ITEMS_INTERVENTIONS: 'ADD_INTERVENTIONS_ITEMS',
    SET_ITEM_INTERVENTIONS: 'SET_INTERVENTIONS_ITEM',

    SET_COUNT_INTERVENTIONS: 'INTERVENTIONS_SET_COUNT',
};
